import { LinearProgress, linearProgressClasses, Pagination } from "@mui/material";
import styled, { css } from "styled-components";

export const EthereumPlaceholderLogo = () => {
  return (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_407_30714)">
        <path
          d="M4.90998 0L4.80273 0.364508V10.9417L4.90998 11.0487L9.81979 8.14657L4.90998 0Z"
          fill="#343434"
        />
        <path d="M4.90981 0L0 8.14657L4.90981 11.0488V5.91494V0Z" fill="#8C8C8C" />
        <path
          d="M4.90955 11.9788L4.84912 12.0525V15.8203L4.90955 15.9969L9.82228 9.07812L4.90955 11.9788Z"
          fill="#3C3C3B"
        />
        <path d="M4.90981 15.9969V11.9788L0 9.07812L4.90981 15.9969Z" fill="#8C8C8C" />
        <path d="M4.90967 11.0478L9.8194 8.1457L4.90967 5.91406V11.0478Z" fill="#141414" />
        <path d="M0 8.1457L4.90974 11.0478V5.91406L0 8.1457Z" fill="#393939" />
      </g>
      <defs>
        <clipPath id="clip0_407_30714">
          <rect width="9.82254" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const InfoContentStyle = styled.div`
  width: 100%;
  height: 100%;
  padding: 12px;
  background: var(--Surface-surface-secondary, #f8f9f9);
  border-radius: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

export const FieldMinStakeButton = styled.button`
  width: 40px;
  height: 24px;
  color: white;
  padding: 4px 8px;
  background: #002035;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
`;

export const EndAdormentStyledLabel = styled.span`
  color: #5c6469;
  font-size: 14px;
  white-space: nowrap;
  background-color: #f8f9f9;
  padding: 4px 8px;
`;

export const CalendarIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.936 2.06641H1.064C1.02865 2.06641 1 2.09506 1 2.13041V16.9355C1 16.9709 1.02865 16.9995 1.064 16.9995H16.936C16.9713 16.9995 17 16.9709 17 16.9355V2.13041C17 2.09506 16.9713 2.06641 16.936 2.06641Z"
        stroke="#002035"
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 6.33398H17"
        stroke="#002035"
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.2002 1V3.13312"
        stroke="#002035"
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.7998 1V3.13312"
        stroke="#002035"
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const StyledDatePicker = styled.div<{ variant?: "mobile" }>`
  width: 100%;
  height: 100%;
  padding: ${({ variant }) => (variant ? "12px 16px" : "3px 6.2px")};
  background: ${({ variant }) => (variant ? "#FFFFFF" : "#f8f9f9")};
  border-radius: ${({ variant }) => (variant ? "10px" : "20px")};
  outline: 1px #e5e9eb solid;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
  &:hover {
    background: #e5e9eb;
    cursor: pointer;
  }
  &:active {
    background: #e5e9eb;
  }
  &:focus {
    background: #e5e9eb;
  }
`;

export const StyledBadge = styled.div<{ available: boolean }>`
  background: ${({ available }) => (available ? "#002035" : "#E5E5E5")};
  border-radius: 8.89px;
  padding: 6px;
  width: 8px;
  height: 8px;
`;

export const StyledStakedspan = styled.span`
  color: #002035;
  font-size: 14px;
  font-family: Söhne;
  font-weight: 400;
  line-height: 17px;
  word-wrap: break-word;
`;

export const StyledSelectbuyorsellspan = styled.span`
  color: #5c6469;
  font-size: 14px;
  font-family: Roobert;
  font-weight: 400;
  line-height: 16px;
  word-wrap: break-word;
`;

export const StyledTextContent = styled.span`
  color: #002035;
  font-size: 19px;
  font-family: Roobert;
  font-weight: 500;
  line-height: 24px;
  word-wrap: break-word;
`;

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#252525",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#0BEC9F",
  },
}));

export const TableSwitch = styled.button<{ active: boolean }>`
  color: ${({ active }) => (active ? "#002035" : "#5C6469")};
  background: ${({ active }) => (active ? "#F8F9F9" : "#FFFFFF")};
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 16px;
  font-family: Roobert;
  font-weight: 500;
  word-wrap: break-word;
  // onHover
  &:hover {
    background: #f8f9f9;
  }
  // pressed
  &:active {
    background: #e5e9eb;
  }
`;

// Filter styles
export const StyledEntertextspan = styled.button<{ active?: boolean }>`
  color: #002035;
  background: ${({ active }) => (active ? "#E5E9EB" : "#FFFFFF")};
  border-radius: 16px;
  border: 1px solid ${({ active }) => (active ? "#FFFFFF" : "#E5E9EB")};
  padding: 3px 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 14px;
  font-family: Roobert;
  font-weight: 400;
  line-height: 16px;
  word-wrap: break-word;
  &:hover {
    background: ${({ active }) => (active ? "#E5E9EB" : "#F8F9F9")};
    border: 1px solid ${({ active }) => (active ? "#FFFFFF" : "#E5E7E8")};
  }
  svg {
    display: block;
  }
  &:active {
    background: #e5e9eb;
    border: 1px solid #ffffff;
  }
`;

export const FilterIcon = () => (
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 12C10.3137 12 13 9.31371 13 6C13 2.68629 10.3137 0 7 0C3.68629 0 1 2.68629 1 6C1 9.31371 3.68629 12 7 12Z" />
    <path
      d="M4.25006 5.8C5.04535 5.8 5.69006 5.1732 5.69006 4.4C5.69006 3.6268 5.04535 3 4.25006 3C3.45477 3 2.81006 3.6268 2.81006 4.4C2.81006 5.1732 3.45477 5.8 4.25006 5.8Z"
      stroke="black"
      stroke-width="1.125"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1 4.40063H2.81008"
      stroke="black"
      stroke-width="1.125"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.69019 4.40063H13.0001"
      stroke="black"
      stroke-width="1.125"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.74981 9.72004C10.5451 9.72004 11.1898 9.09324 11.1898 8.32004C11.1898 7.54684 10.5451 6.92004 9.74981 6.92004C8.95452 6.92004 8.30981 7.54684 8.30981 8.32004C8.30981 9.09324 8.95452 9.72004 9.74981 9.72004Z"
      stroke="black"
      stroke-width="1.125"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13 8.32068H11.1899"
      stroke="black"
      stroke-width="1.125"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.30992 8.32068H1"
      stroke="black"
      stroke-width="1.125"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const StyledDivider = styled.div`
  width: 100%;
  height: 100%;
  outline: 1px #e5e7e8 solid;
  outline-offset: -0.5px;
`;

// Used when different elements shares the same styles
const RootRoobertMediumDarkStyles = css`
  color: #002035;
  font-size: 14px;
  font-family: Roobert;
  font-weight: 500;
`;

const RootSmallSpanRoobertNormalDarkStyles = css`
  color: #002035;
  font-size: 14px;
  font-family: Roobert;
  font-weight: 400;
`;

export const SmallThRoobertMediumDark = styled.th`
  ${RootRoobertMediumDarkStyles};
`;

export const SmallSpanRoobertMediumDark = styled.span`
  ${RootRoobertMediumDarkStyles};
`;

export const SmallTdRoobertNormalDark = styled.td`
  ${RootSmallSpanRoobertNormalDarkStyles};
`;

export const SmallSpanRoobertNormalDark = styled.span`
  ${RootSmallSpanRoobertNormalDarkStyles};
`;

// Styled tr
export const StyledTableRow = styled.tr`
  height: 48px;
`;

// Styled table
export const StyledTable = styled.table`
  width: 100%;
  text-align: left;
  border-collapse: separate; /* ensure gaps are rendered */
  border-spacing: 0 10px;
`;

export const StyledTableDataLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: #5c6469;
`;

export const SmallSohneTextSpan = styled.span`
  color: #5c6469;
  font-size: 12px;
  font-family: Söhne;
  font-weight: 400;
  line-height: 14px;
  word-wrap: break-word;
`;

// If variant mobile width 100%
export const StakeButton = styled.button<{ variant?: "mobile" }>`
  background: #002035;
  color: #ffffff;
  border: none;
  border-radius: 16px;
  padding: 4px 9px;
  cursor: pointer;
  font-weight: ${({ variant }) => (variant === "mobile" ? 500 : 600)};
  width: ${({ variant }) => (variant === "mobile" ? "100%" : "auto")};
  &:hover {
    background: #4e7086;
  }
  // active
  &:active {
    background: #e8f6ff;
    color: #002035;
  }
`;

// Unstake Button
export const UnstakeButton = styled.button<{ variant?: "mobile" }>`
  background: #f8f9f9;
  color: #002035;
  border: none;
  border-radius: 16px;
  padding: ${({ variant }) => (variant === "mobile" ? "12px 8px" : "4px 9px")};
  width: ${({ variant }) => (variant === "mobile" ? "100%" : "auto")};
  cursor: pointer;
  &:hover {
    padding: ${({ variant }) => (variant === "mobile" ? "11px 7px" : "3px 8px")};
    background: #f8f9f9;
    border: 1px solid #e5e7e8;
  }
  // active
  &:active {
    background: #e5e9eb;
  }
`;

export const StyledLargeChipbutton = styled.button<{ selected?: boolean }>`
  color: ${({ selected }) => (selected ? "#ffffff" : "#002035")};
  max-width: 133px;
  font-size: 16px;
  width: 100%;
  height: 100%;
  padding: 8px 28px;
  background: ${({ selected }) => (selected ? "#002035" : "#ffffff")};
  overflow: hidden;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
  &::after {
    content: "";
    min-width: 8px;
    width: 8px;
    height: 8px;
    background: #ff3b30;
    border-radius: 50%;
    display: ${({ selected }) => (selected ? "block" : "none")};
    margin-left: 2px;
  }
  &:hover {
    background: #4e7086;
    color: #ffffff;
  }
`;

export const StyledContainedbuttons = styled.button`
  width: 100%;
  height: 100%;
  padding: 12px 16px;
  background: #f8f9f9;
  border-radius: 10px;
  font-size: 14px;
  font-family: Roobert;
  border: none;
  cursor: pointer;
  font-weight: 400;
  &:hover {
    background: #4e7086;
    color: #ffffff;
  }
  // active
  &:active {
    background: #e5e9eb;
  }
`;

// Styled MUI Pagination
export const StyledPagination = styled(Pagination)`
  & .MuiPaginationItem-page {
    color: black;
    border: none;
    background-color: #ffffff;
  }

  & .MuiPaginationItem-page.Mui-selected {
    background-color: transparent;
    font-weight: 600;
    position: relative;
  }

  & .MuiPaginationItem-page.Mui-selected::after {
    content: "";
    position: absolute;
    bottom: 6px;
    left: 50%;
    transform: translateX(-35%);
    height: 1.5px;
    width: 20%;
    background-color: #002035;
  }
`;
